module.exports = __webpack_public_path__ + "static/media/gel-top.bc21c271.svg";